import React from 'react';
import { Box } from '../../base/Box/Box';
import { Type } from '../../base/Type/Type';
import { ManualNewsSectionStoryblok } from '../../types/storyblok';
import parseNews from '../../utils/parseNews';
import NewsArticleCard from '../../components/NewsArticleCard/NewsArticleCard';
import { graphql, useStaticQuery } from 'gatsby';

const ManualNewsSection = ({
  title,
  category,
  articles,
  colourScheme,
}: ManualNewsSectionStoryblok) => (
  <Box as="section" colourScheme={colourScheme || 'white'} blockSpacing bkg>
    <Box as="div" className="mx-auto max-w-standard">
      <Type as="h3" typography="subheading">
        {category}
      </Type>
      <Type as="h2" className="mb-10 font-helvetica text-h2 md:mb-25">
        {title}
      </Type>
      <Box
        as="div"
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-3 gap-y-5"
      >
        {articles.map((article) => (
          <NewsArticleCard {...article} />
        ))}
      </Box>
    </Box>
  </Box>
);

const ManualNewsSectionContainer = ({
  articles,
  ...props
}: ManualNewsSectionStoryblok) => {
  const data = useStaticQuery(graphql`
    query {
      stories: allStoryblokEntry(
        filter: {
          field_title_string: { ne: null }
          full_slug: { regex: "/^articles//" }
          field_component: { in: ["NewsItem", "page"] }
        }
      ) {
        nodes {
          field_component
          field_title_string
          field_description_string
          field_category_string
          field_datePublished_string
          field_link_string
          field_quote_string
          full_slug
          uuid
        }
      }
    }
  `);

  const nodes = articles
    .map((article) => data.stories.nodes.find((node) => node.uuid === article))
    .filter((value) => !!value)
    .map(parseNews);

  return <ManualNewsSection articles={nodes} {...props} />;
};

export default ManualNewsSectionContainer;
